import {useTranslation} from "react-i18next";
import DateDisplay from "components/datetime/DateDisplay";

const TableHistory = ({itemsShown}) => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tags");
    const {t: _Tc} = useTranslation("choices");

    const stickyHeaderStyle = {
        position: "sticky",
        top: "153px",
        backgroundColor: "white",
        zIndex: 899,
    };

    // console.log("items.current.chosen", items.current.chosen);

    return (
        <>
            <div className="col-12">
                {itemsShown.length === 0 ? (
                    <div className="alert alert-secondary text-center">{_Tt("common.noData")}</div>
                ) : (
                    <table className="table table-striped sticky-horizontal">
                        <thead>
                            <tr>
                                <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                                    {_Tt("common.action")}
                                </th>
                                <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                                    {_Tt("common.date")}
                                </th>
                                <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                                    {_Tt("common.user")}
                                </th>
                                <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                                    {_Tt("common.message")}
                                </th>
                                <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                                    {_Tt("common.status")}
                                </th>

                                <th style={{...stickyHeaderStyle}} className="sticky-top border-bottom-sticky">
                                    {_Tt("common.models")}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {itemsShown.map((log) => (
                                <tr key={log.id}>
                                    <td>{_Tc(`actions.${log.action}`)}</td>
                                    <td>
                                        <DateDisplay date={log.created_at} format="DD/MM/YYYY HH:mm" title={true} />
                                    </td>
                                    <td>{log.user_name}</td>
                                    <td>{log.message}</td>
                                    <td>{log.level}</td>
                                    <td>{log.model}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </>
    );
};

export default TableHistory;
